import script from "./DualRangeSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./DualRangeSlider.vue?vue&type=script&setup=true&lang=ts"

import "./DualRangeSlider.vue?vue&type=style&index=0&id=d2a27bc8&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2a27bc8"]])

export default __exports__